import { Rule } from '../shared'
import { Connector } from '../../../../../api/connector'

export interface GetRulesArgs {
  organizationUuid?: string
}

export interface GetRulesResponse {
  rules: Rule[]
}

export async function getRules(
  this: {
    connector: Connector
  },
  { organizationUuid }: GetRulesArgs
) {
  const { rules } = await this.connector.get<GetRulesResponse>(
    `/${organizationUuid}/rules?expand=skip_links&base=true`
  )
  return rules
}
